import { TonClient } from "@ton/ton";
import { Address } from "@ton/core";
const DEFAULT_ENDPOINTS = {
    mainnet: "https://toncenter.com/api/v2/jsonRPC",
    testnet: "https://testnet.toncenter.com/api/v2/jsonRPC",
};
export function makeTonClient(opts = {}) {
    const network = opts.network ?? "testnet";
    const endpoint = opts.endpoint ?? DEFAULT_ENDPOINTS[network];
    return new TonClient({ endpoint, apiKey: opts.apiKey });
}
export function parseAddress(s) {
    return Address.parse(s);
}
/**
 * Convert a TON address to a field element matching the on-chain encoding in
 * `apps/contracts/contracts/pool_native.tolk` :: `address_to_field`.
 *
 * Layout (≤ 248 bits, fits cleanly in the 255-bit BLS12-381 scalar field):
 *   bits [247..240]:  workchain & 0xff    (so masterchain -1 maps to 0xff)
 *   bits [239..0]:    high 240 bits of the 256-bit account hash
 *
 * The low 16 bits of the hash are discarded. Preimage resistance is 240 bits,
 * well above the 128-bit security target of the curve. This MUST match the
 * Tolk implementation byte-for-byte or proofs will fail on-chain.
 */
export function addressToFieldElement(addr) {
    const hash = BigInt("0x" + addr.hash.toString("hex"));
    const wc = BigInt(addr.workChain) & 0xffn;
    return (wc << 240n) | (hash >> 16n);
}
/**
 * Inverse of `addressToFieldElement`. Note that the low 16 bits of the hash
 * are lost in the forward transform, so this returns one of 2^16 addresses
 * that map to the same field element — useful only for display / debugging,
 * NOT for tx routing.
 */
export function fieldElementToAddress(value, workchain) {
    const wc = workchain ?? Number((value >> 240n) & 0xffn);
    // Reconstruct the high 240 bits; the low 16 bits are zeroed.
    const hashHigh240 = value & ((1n << 240n) - 1n);
    const hashFull = hashHigh240 << 16n;
    const hex = hashFull.toString(16).padStart(64, "0");
    const buf = Buffer.from(hex, "hex");
    // Treat masterchain (0xff in the encoding) as -1.
    const signedWc = wc === 0xff ? -1 : wc;
    return new Address(signedWc, buf);
}
//# sourceMappingURL=tonClient.js.map